// Version : 0.0.3
// Author : VIGNESH
// LastEdit : VIGNESH
// Last ADD : REMOVED UNWANTED REDUX
// MODFIED DATA : 07-12-2025

import AccountDayBookReportActionTypes from './day-book-report.types';

// /** ***************** FETCH ACCOUNT DAY BOOK REPORT START *********************** */
export const fetchDayBookReportStart = (getData: any) => ({
	type: AccountDayBookReportActionTypes.FETCH_DAY_BOOK_REPORT_START,
	payload: getData,
});

export const fetchDayBookReportSuccess = (successData: any) => ({
	type: AccountDayBookReportActionTypes.FETCH_DAY_BOOK_REPORT_SUCCESS,
	payload: successData,
});

export const fetchDayBookReportFailure = (failureData: any) => ({
	type: AccountDayBookReportActionTypes.FETCH_DAY_BOOK_REPORT_FAILURE,
	payload: failureData,
});

export const fetchDayBookReportResponseResetStart = () => ({
	type: AccountDayBookReportActionTypes.FETCH_DAY_BOOK_REPORT_RESPONSE_RESET,
});

export const fetchDayBookReportResponseChanged = () => ({
	type: AccountDayBookReportActionTypes.FETCH_DAY_BOOK_REPORT_RESPONSE_CHANGED,
});
/***************** FETCH ACCOUNT DAY BOOK REPORT END ************************/
